// @flow

import React, { type Node } from 'react';
import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';

export function MailWarning(): Node {
  const incomingPayment = useIncomingPayment();
  return (
    <Root>
      Uma cópia já foi enviada para <strong>{getCustomerEmail(incomingPayment)}</strong>,
      mas se preferir você pode pagar usando as informações abaixo:
    </Root>
  );
}

const Root = styled.p`
  text-align: left;
  margin-bottom: 16px;
  font-weight: 400;
`;
